module.exports = __webpack_public_path__ + "img/etebari-tosee.6381eb29.svg";